import React, { Component } from "react";
import { ToastContainer } from "react-toastify";
import toast from "../helpers/toast";
import Httpconfig from "../helpers/HttpconfigAdmin";
import Constant from "../../constants";
import { MDBDataTable } from "mdbreact";
import { Link } from "react-router-dom";
const moment = require("moment");
export default class Viewpatients extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page_data: "",
      datatable: {
        columns: [
          {
            label: "ID",
            field: "id",
            sort: "asc",
            width: 150,
          },
          {
            label: "User_id",
            field: "user_id",
            sort: "asc",
            width: 150,
          },
          {
            label: "Name",
            field: "name",
            sort: "asc",
            width: 10,
          },
          {
            label: "Last_name",
            field: "last_name",
            sort: "asc",
            width: 10,
          },
          {
            label: "DOB",
            field: "dob",
            sort: "asc",
            width: 10,
          },
          {
            label: "Gender",
            field: "gender",
            sort: "asc",
            width: 10,
          },
          {
            label: "PhoneNumber",
            field: "phone_number",
            sort: "asc",
            width: 10,
          },
        ],
        rows: [],
      },
    };
    this.deletePatient = this.deletePatient.bind(this);
  }

  // To get detais after first render
  componentDidMount = () => {
    this.fetchpagesdata();
  };

  // When value changes of the fields
  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  // For getting the data
  fetchpagesdata() {
    Httpconfig.httptokenget(Constant.siteurl + "api/Patients")
      .then((response) => {
        this.setState({
          page_data: response.data.data,
        });
        let assignvalues = [];
        this.items = response.data.data.map((item, key) => {
          assignvalues.push({
            id: item.id,
            user_id: item.user_id,
            name: item.name,
            last_name: item.last_name,
            dob: moment(item.dob).format("Do MMMM,YYYY"),
            gender: item.gender,
            phone_number: item.phone_number,
          });
        });

        let couponState = Object.assign({}, this.state);

        couponState.datatable.rows = assignvalues;
        this.setState(couponState);
      })
      .catch((error) => {});
  }

  //delete controller
  deletePatient(patientId, name) {
    var isConfirm = window.confirm("Are you sure to delete " + name + "?");
    if (isConfirm) {
      Httpconfig.httptokendelete(Constant.siteurl + "api/Patients/" + patientId)
        .then((response) => {
          toast.success("Successfully Deleted patient");
          setTimeout(() => window.location.reload(), 2000);
        })
        .catch((error) => {
        });
    }
  }
  render() {
    const { datatable } = this.state;
    return (
      <section id="main_dashboard">
        <div className="container" id="main_front">
          <div className="row">
            <div className="col-md-12">
              <div className="dash-section">
                <div className="section-header">
                  <ol className="breadcrumb">
                    <li className="active">
                      <Link to="/admin"> Dashboard</Link> &gt; Patients
                    </li>
                  </ol>
                </div>
              </div>

              <section id="CMS_tab">
                <div className="CMS_content">
                  <div className="container">
                    <div className="row">
                      <div className="tab-header">
                        <h3> View Patients </h3>
                      </div>
                      <div id="reg_form">
                        {datatable.rows.length === 0 ? (
                          <p>Loading............</p>
                        ) : (
                          <MDBDataTable
                            striped
                            responsive
                            bordered
                            small
                            data={datatable}
                          />
                        )}
                        <div className="row">
                          <div className="col-md-12">
                            <div
                              className="update_btn"
                              style={{ textAlign: "right" }}
                            ></div>
                          </div>
                        </div>
                        <ToastContainer />
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </section>
    );
  }
}
